module.exports = __webpack_public_path__ + "img/background_button_toggle.c71e123a.png";